{{
  (notification.errorCode
    ? 'Exception::' + notification.errorCode
    : 'Project::ProjectImportFailedMessage'
  ) | abpLocalization
}}
